<div class="global-search-wrapper relative ml-auto mr-4 flex h-full w-full min-w-[120px] max-w-[300px] flex-1 items-center overflow-visible">
  <ng-container [formGroup]="searchForm">
    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input pInputText type="text" placeholder="Search" formControlName="globalSearch"
        id="globalSearch" title="Global Search" autocomplete="off" />
    </span>
  </ng-container>

  <div 
    *ngIf="showDropdown" 
    class="search-results-dropdown keep-open absolute left-auto right-0 top-full z-[9999] mt-[2px] w-[min(500px,calc(100vw-2rem))] min-w-full max-w-[calc(100vw-2rem)] overflow-hidden rounded border border-[#dee2e6] bg-white shadow-[0_2px_8px_rgba(0,0,0,0.1)] max-h-[min(400px,70vh)]"
    (click)="$event.stopPropagation()"
  >
    
    <div *ngIf="isLoading" class="loading-container">
      <div class="flex justify-center">
        <p-progressSpinner ariaLabel="loading" />
      </div>
    </div>
    
    <div *ngIf="!isLoading && searchResults && searchResults.results.length > 0" class="search-results-content">
      <div class="search-results-header">
        <span class="results-count">{{ searchResults.totalCount }} results found</span>
      </div>
      
      <div class="search-results-list">
        <div 
          *ngFor="let result of searchResults.results" 
          class="search-result-item"
          (click)="onResultClick(result)"
        >
          <div class="result-icon">
            <i *ngIf="result.type === 'Customer'" class="fas fa-user"></i>
            <i *ngIf="result.type === 'Quote'" class="fas fa-file-invoice"></i>
          </div>
          
          <div class="result-content overflow-hidden">
            <div class="result-title break-words [overflow-wrap:anywhere]" [innerHTML]="getHighlightedTitle(result)"></div>
            

            <div class="result-contact" *ngIf="getContactFields(result).length > 0">
              <span
                *ngFor="let field of getContactFields(result)"
                class="contact-field"
                [attr.data-field-name]="field.fieldName"
              >
                <i
                  class="pi"
                  [ngClass]="{
                    'pi-phone': field.fieldName === 'Phone',
                    'pi-envelope': field.fieldName === 'Email',
                    'pi-map-marker': field.fieldName === 'Zip Code',
                    'pi-user': field.fieldName === 'Age'
                  }"
                ></i>
                <span class="contact-label">{{ field.fieldName }}:</span>
                <span class="contact-value" [innerHTML]="field.highlightedValue"></span>
              </span>
            </div>
            
            <div class="result-highlights">
              <span 
                *ngFor="let field of getDisplayFields(result)" 
                class="highlight-field"
                [class.matched]="field.isMatched"
              >
                <strong>{{ field.fieldName }}:</strong> 
                <span [innerHTML]="field.highlightedValue"></span>
              </span>
            </div>
          </div>
        </div>
      </div>
      
      <div *ngIf="searchResults.hasMore" class="search-results-footer">
        <button class="view-all-btn" (click)="onViewAll()">
          View all {{ searchResults.totalCount }} results
        </button>
      </div>
      
    </div>
    
    <div *ngIf="!isLoading && searchResults && searchResults.results.length === 0" class="no-results">
      <p>No results</p>
    </div>
  </div>
</div>
